export const getBrand = (state) => state.brand
